// React singleton
/**
 * This module exports a single React instance to be used throughout the application.
 * This helps prevent issues with multiple React instances causing context errors.
 */

// Ensure React is properly loaded and available globally first
import '../react-init';

// Now import React directly
import * as React from 'react';

// Log React availability for debugging
console.log('[react-singleton] React loaded:', {
  version: React?.version,
  createContextAvailable: typeof React?.createContext === 'function'
});

// Verify React is properly loaded
if (!React || typeof React.createContext !== 'function') {
  console.error('[react-singleton] CRITICAL ERROR: React is not properly loaded');
  throw new Error('React is not properly loaded. createContext is not available.');
}

// Export the React instance
export default React;

// Re-export common hooks and components to ensure consistent usage
export const {
  useState,
  useEffect,
  useContext,
  useReducer,
  useCallback,
  useMemo,
  useRef,
  createContext,
  createElement,
  Fragment,
  memo,
  forwardRef,
  Children,
  isValidElement,
  cloneElement,
  createRef,
  Component,
  PureComponent,
  Suspense,
  lazy,
} = React;
